<template>
  <div class="charges">
    <!-- 收费标准 -->
    <p class="charges-title">
      刊登樓盤收費說明(售盤及租盤同價)
    </p>
    <div class="ad">
      <div class="ad-time">
        <span>放盤廣告類型</span>
        <span>如對付款或放盤有問題，歡迎致電查詢：3619-3200，星期一至五，上午9時到下午6時。</span>
      </div>
      <div class="ad-contant">
        <tr
          v-if="isUseRealEstate.isUseStandard"
          class="one_line"
        >
          <td class="one-row">
            <span>標準盤</span>
          </td>
          <!-- <td class="two-row">
                        <span>
                            現在有
                            <span class="number">{{ normalPropertyCount }}</span
                            >個盤使用中
                        </span>
                    </td> -->
          <td class="three-row">
            <span>一般放盤：</span>
          </td>
          <td class="four-row">
            <span>{{ oneLine.propertyCoin }}金幣</span>
          </td>
          <td class="five-row">
            <span class="ad-five">有效期：售盤{{ oneLine.effectiveDays }}天 / 租盤{{ oneLine.rentEffectiveDays }}天</span>
          </td>
        </tr>
        <tr
          v-if="isUseRealEstate.isUseSuper"
          class="two_line"
        >
          <td class="one-row">
            <span>精選盤</span>
          </td>
          <!-- <td class="two-row">
                        <span>
                            現在有
                            <span class="number">{{ goldTopPropertyCount }}</span
                            >個盤使用中
                        </span>
                    </td> -->
          <td class="three-row">
            <span>比標準盤更有效曝光：</span>
          </td>
          <td class="four-row">
            <div class="price">
              <p>
                <span>{{ twoLine.diamond }}</span>鑽石
              </p>
            </div>
          </td>
          <td class="five-row">
            <span class="ad-five">有效期：售盤{{ twoLine.effectiveDays }}天 / 租盤{{ twoLine.rentEffectiveDays }}天</span>
          </td>
        </tr>
        <tr
          v-if="isUseRealEstate.isUseStar"
          class="three_line"
        >
          <td class="one-row">
            <span>星級盤</span>
          </td>
          <!-- <td class="two-row">
                        <span>
                            現在有
                            <span class="number">{{ starPropertyCount }}</span
                            >個盤使用中
                        </span>
                    </td> -->
          <td class="three-row">
            <span>比精選盤及標準盤有較高曝光機會：</span>
          </td>
          <td class="four-row">
            <div class="price">
              <p>
                售盤
                <span class="crossing">{{ Star_Buy.diamond }}</span>鑽石 / 租盤 <span class="crossing">{{ Star_Rent.diamond }}</span>鑽石
              </p>
            </div>
          </td>
          <td class="five-row">
            <span class="ad-five">有效期：售盤{{ Star_Buy.effectiveDays }}天 / 租盤{{ Star_Rent.rentEffectiveDays }}天</span>
          </td>
        </tr>
      </div>
    </div>
    <div class="proxy">
      地產代理：我們另有代理套餐給香港的持牌代理人或公司使用，如有興趣，歡迎與我們銷售部聯絡(電話：6425 0808 或 3619 3218)
    </div>
    <a
      class="btn"
      @click.stop="dialogVisible = true"
    >立即放盤</a>
    <div class="remark">
      <p>備註：</p>
      <p>1、成功放盤後，樓盤會同時顯示與house730網站及手機應用程式。</p>
      <p>2、每個放盤只能指定為售盤或租盤，不能同時放售或放租。</p>
      <p>3、售盤、租盤及續期收費相同。</p>
    </div>
    <!-- 对话框 -->
    <el-dialog
      title="刊登樓盤"
      width="480px"
      :visible.sync="dialogVisible"
    >
      <div class="post-enter">
        <el-row>
          <el-col :span="12">
            <el-button
              type="primary"
              @click="sale"
            >
              刊登售盤
            </el-button>
          </el-col>
          <el-col :span="12">
            <el-button
              type="primary"
              @click="rent"
            >
              刊登租盤
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!-- <el-dialog title="刊登樓盤"
               :visible.sync="dialogVisible"
               width="33%">
      <div class="show">
        <el-button type="primary"
                   @click="sale" class="check">刊登售盤</el-button>
        <el-button type="primary"
                   @click="rent" class="check">刊登租盤</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
export default {
    data() {
        return {
            oneLine: '',
            twoLine: '',
            Star_Buy: '',
            Star_Rent: '',
            type: '',
            normalPropertyCount: 0,
            goldTopPropertyCount: 0,
            starPropertyCount: 0,
            dialogVisible: false,
            isUsedDiamond: true,
            isUsedCoin: false,
            isUseRealEstate: {} //是否展示楼盘数据
        };
    },
    created() {
        this.SearchPropertyPriceSet();
        this.GetPropertyCount();
        this.getcompany();
    },

    methods: {
        // 获取公司类型
        async getcompany() {
            const { data } = await this.axios.get(this.pub.getApi().GetCompanyCofig);
            // console.log('获取公司类型', data.result);
            //是否展示楼盘数据
            this.isUseRealEstate = {
                isUseStandard: data.result.isUseStandard,
                isUseStar: data.result.isUseStar,
                isUseSuper: data.result.isUseSuper
            };
            // 判断是否启用钻石
            data.result.isUsedDiamond ? (this.isUsedDiamond = true) : (this.isUsedDiamond = false);
            data.result.isUsedCoin ? (this.isUsedCoin = true) : (this.isUsedCoin = false);
            if (data.result.isProhibitPublishGoldTop) {
                this.type = false;
            } else {
                this.type = true;
            }
        },
        // 选择售/租
        sale() {
            this.$router.push('/property/post?rentalType=1');
        },
        rent() {
            this.$router.push('/property/post?rentalType=2');
        },
        // 获取房源数量
        async GetPropertyCount() {
            const { data } = await this.axios.get(this.pub.getApi().GetPropertyCount);
            let count = data.result;
            this.goldTopPropertyCount = count.goldTopPropertySaleCount + count.goldTopPropertyRentCount;
            this.normalPropertyCount = count.normalPropertyRentCount + count.normalPropertySaleCount;
            this.starPropertyCount = count.starPropertyRentCount + count.starPropertySaleCount;
        },
        // 获取价格标准
        async SearchPropertyPriceSet() {
            const {
                data: { result }
            } = await this.axios.get(this.pub.getApi().SearchPropertyPriceSet);
            console.log(result, '获取价格标准');

            result.forEach(item => {
                if (item.itemNameCulture === '標準盤') {
                    this.oneLine = item;
                }
                if (item.itemNameCulture === '精選盤') {
                    this.twoLine = item;
                }
                if (item.itemName === 'Star_Buy') {
                    this.Star_Buy = item;
                }
                if (item.itemName === 'Star_Rent') {
                    this.Star_Rent = item;
                }
            });

            console.log(this.oneLine, this.twoLine, this.Star_Buy, this.Star_Rent, '11111111');
        }
    }
};
</script>
<style lang="less">
.post-enter {
    padding: 25px 30px 40px;
    text-align: center;
    button {
        padding: 16px 18px;
        border-radius: 10px;
    }
    span {
        font-size: 30px;
    }
}
p {
    margin: 0;
    padding: 0;
}

.charges {
    text-align: left;
    .el-dialog {
        margin-top: 0;
        border-radius: 10px;
        // top: 50%-15vh;
        top: 40%;
        transform: translateY(-50%);
        .el-dialog__header {
            border-radius: 10px 10px 0 0;
            background-color: rgb(250, 250, 251);
            padding: 10px;
            border-bottom: 1px solid #ccc;
            .el-dialog__title {
                color: #999;
                font-size: 14px;
            }
            .el-dialog__headerbtn {
                top: 15px;
                right: 10px;
            }
        }
    }
    .show {
        display: flex;
        justify-content: space-between;
        .check {
            font-size: 30px;
        }
    }
    .charges-title {
        font-family: PingFangSC-Regular;
        font-size: 24px;
        color: #171725;
        letter-spacing: 0.1px;
        margin-bottom: 32px;
    }
    .ad {
        overflow: hidden;
        width: 100%;
        // height: 201px;
        padding: 5px;
        border: 1px solid #e2e2ea;
        border-radius: 23px;
        .ad-time {
            width: 100%;
            height: 55px;
            line-height: 55px;
            span:nth-child(1) {
                margin: 0px 25px 20px 20px;
                font-family: MicrosoftYaHei;
                font-size: 16px;
                color: #696974;
                letter-spacing: 0.1px;
            }
            span:nth-child(2) {
                font-family: MicrosoftYaHei;
                font-size: 16px;
                color: #e50113;
                letter-spacing: 0.1px;
            }
        }
        .ad-contant {
            box-sizing: border-box;
            margin: 0 5px;
            // height: 140px;
            padding: 26px 0;
            background: #ffffff;
            border-radius: 20px;
            .one_line {
                // padding-top: 35px;
                // padding-bottom: 21px;
                padding: 10px 0;
                // margin-left: 106px;
            }
            .two_line {
                padding: 10px 0;
                // margin-left: 106px;
            }
            .three_line {
                padding: 10px 0;
                // margin-left: 106px;
            }
            tr {
                display: flex;
                // margin-bottom: 23px;
                td {
                    flex: 3;

                    span {
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        color: #696974;
                        letter-spacing: 0.1px;
                    }
                }
            }
            .one-row {
                width: 97px;
                text-align: center;
                flex: 2;
                span:nth-child(1) {
                    font-family: PingFangSC-Semibold;
                    font-size: 16px;
                    color: #171725;
                    letter-spacing: 0.1px;
                }
                span:nth-child(2) {
                    font-family: PingFangSC-Regular;
                    font-size: 16px;
                    color: #0b0b13;
                    letter-spacing: 0.1px;
                    line-height: 22px;
                }
            }
            .two-row {
                width: 160px;
                // padding-right: 55px;
                text-align: left;
                .number {
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #e50416;
                    letter-spacing: 0.1px;
                    line-height: 20px;
                }
            }
            .three-row {
                flex: 3;
                box-sizing: border-box;
                width: 85px;
                padding-right: 15px;
                text-align: right;
            }
            .four-row {
                width: 136px;
                // padding-right: 38px;
                p {
                    font-size: 14px;
                    color: #696974;
                    font-family: PingFangSC-Regular;
                    letter-spacing: 0.1px;
                }
            }
            .five-row {
                flex: 4;
                text-align: left;
            }
            .absolute {
                position: absolute;
                top: -8px;
            }
            .two_line {
                .four-row {
                    position: relative;
                }
                .price {
                    position: absolute;
                    // top: -8px;
                    p {
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        color: #696974;
                        letter-spacing: 0.1px;
                    }
                }
                .crossing {
                    // text-decoration: line-through;
                }
            }
        }
    }

    .proxy {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #171725;
        letter-spacing: 0;
        margin-top: 10px;
        margin-bottom: 45px;
    }
    .btn {
        display: block;
        width: 140px;
        height: 38px;
        text-align: center;
        line-height: 38px;
        cursor: pointer;
        background-color: #e50113;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #ffffff;
        outline: 0;
        letter-spacing: 0.11px;
        border-radius: 10px;
        margin-bottom: 10px;
    }
    .remark {
        height: 104px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #696974;
        letter-spacing: 0;
        line-height: 26px;
    }
}
</style>
